import React from 'react';
import { formatBoxDimensionToken } from './BoxDimensionConfirmModal';
import type { BoxDimensions } from '../parseBoxDimensions';
import './PackingPhotoSheet.css';

interface SuggestedBoxSheetProps {
  readonly dimensions: BoxDimensions;
  readonly saving: boolean;
  readonly error: string;
  readonly onConfirm: () => void;
  readonly onDecline: () => void;
}

export function suggestedBoxLabel(dimensions: BoxDimensions): string {
  const size = [
    formatBoxDimensionToken(dimensions.length),
    formatBoxDimensionToken(dimensions.width),
    formatBoxDimensionToken(dimensions.height),
  ].join('x');
  return `Pack order in ${size}`;
}

export default function SuggestedBoxSheet({
  dimensions,
  saving,
  error,
  onConfirm,
  onDecline,
}: SuggestedBoxSheetProps): React.ReactElement {
  const label = suggestedBoxLabel(dimensions);
  return (
    <div className="packing-photo-sheet" role="dialog" aria-modal="true" aria-label={label}>
      <div className="packing-photo-stage suggested-box-stage">
        <p className="suggested-box-copy">{label}</p>
        {error ? <p className="packing-photo-error" role="alert">{error}</p> : null}
        <div className="packing-photo-review">
          <button
            type="button"
            className="packing-photo-review-btn packing-photo-retake"
            onClick={onDecline}
            disabled={saving}
            aria-label="Scan box size"
          >
            ×
          </button>
          <button
            type="button"
            className="packing-photo-review-btn packing-photo-confirm"
            onClick={onConfirm}
            disabled={saving}
            aria-label="Use this box size"
          >
            {saving ? <span className="packing-photo-spinner" aria-hidden="true" /> : '✓'}
          </button>
        </div>
      </div>
    </div>
  );
}
